import { faCalendar } from "@fortawesome/pro-solid-svg-icons";
import {
  FontAwesomeIcon,
  type FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";

const CalendarIcon = ({ ...props }: Omit<FontAwesomeIconProps, "icon">) => (
  <FontAwesomeIcon icon={faCalendar} {...props} />
);

export { CalendarIcon };
